module.exports = "/images/vc.svg?5a36bdb87568107839f8bf70d166f512";